export default __webpack_public_path__ + "static/media/2801_FVJ_Logo.f15ca461.bmp";